import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const verticalLabelStyles = css `
  flex-direction: column-reverse;
  align-items: center;
`;
const spacingFromSize = {
    small: theme.spacing.md,
    medium: theme.spacing.lg,
};
export const Label = styled.label `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  padding: ${({ $size }) => spacingFromSize[$size]};
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.primary};
  transition: all 0.1s;

  ${({ $alignment }) => $alignment === 'vertical' && verticalLabelStyles};
  ${({ $invalid }) => css `
    border-color: ${$invalid ? theme.swatches.red[500] : theme.semantic.border.default};

    &:hover:not(:has(input:disabled)) {
      border-color: ${$invalid ? theme.swatches.red[500] : theme.swatches.warm[1000]};
      box-shadow: ${theme.dropShadow[400]};
    }

    &:has(input:checked) {
      border-color: ${$invalid ? theme.swatches.red[500] : theme.swatches.warm[1000]};
      background-color: ${$invalid ? theme.semantic.feedback.danger.surface : theme.semantic.surface.sunken};
    }

    &:has(input:focus-visible) {
      border-color: ${$invalid ? theme.swatches.red[200] : theme.semantic.focus.ring};
      outline: ${pxToRem(3)} solid ${$invalid ? theme.swatches.red[200] : theme.semantic.focus.ring};
      box-shadow: ${theme.dropShadow[400]};
    }

    &:has(input:active):not(:has(input:disabled)) {
      border-color: ${$invalid ? theme.swatches.red[500] : theme.swatches.warm[1000]};
      background-color: ${$invalid ? theme.swatches.red[100] : theme.semantic.action.secondary.active};
      box-shadow: ${theme.dropShadow[400]};
    }

    &:has(input:disabled) {
      opacity: 0.5;
      box-shadow: none;
    }
  `};
`;
const verticalInputStyles = css `
  align-self: flex-end;
`;
export const InputOverlay = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  flex: 0 0 ${pxToRem(20)};
  background-color: ${theme.semantic.surface.primary};
  border: ${pxToRem(1)} solid ${theme.semantic.border.strong};
  border-radius: ${({ $type }) => ($type === 'radio' ? theme.borderRadius.circle : theme.borderRadius.sm)};
  ${({ $alignment }) => $alignment === 'vertical' && verticalInputStyles};
  ${({ $invalid }) => css `
    input:checked + & {
      border-color: transparent;
      background-color: ${$invalid ? theme.swatches.red[500] : theme.semantic.surface.inverse};
    }
  `}
`;
export const HiddenInput = styled.input `
  width: 0;
  height: 0;
  opacity: 0;
`;
